import { useEffect, useState } from "react";
import { customersApi, type Customer } from "../../api/customersApi";
import { toClientApiError } from "../../api/httpClient";

/**
 * Resolves a default customer for write operations only.
 * Structure hub lists are tenant-wide; creates still need a customer_id row owner.
 */
export function useCustomerScope() {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [writeCustomerId, setWriteCustomerId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      setLoading(true);
      setError(null);
      try {
        const items = await customersApi.list();
        const active = items.filter((c) => c.status === "active");
        if (cancelled) return;
        setCustomers(active);
        setWriteCustomerId(active[0]?.id ?? null);
      } catch (err) {
        if (!cancelled) {
          setError(toClientApiError(err).message);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { customers, writeCustomerId, loading, error };
}
